import React, { useRef } from "react";
import { Icon, D } from "./icons";
import TrucksMap from "./TrucksMap";

/**
 * Wireframe `.map-panel`: map + `.map-summary` + «Показать все … на карте» (`expand-map`) +
 * `.zoom` (+/−) + `.map-center`. The wireframe's raster is a real Google map; the
 * controls act on it. Inside the expanded-map dialog `onExpand` is omitted (the wireframe
 * removes `.map-all` there).
 */
export default function MapPanel({ points, icon = D.pin, summary, expandLabel, onExpand, onCenter, ariaLabel, wrap = false }) {
  const map = useRef(null);
  return (
    <div className="map-panel" aria-label={ariaLabel} data-zoom="1">
      <TrucksMap ref={map} points={points} />
      <div className="map-summary">
        {wrap ? (
          <span>
            <Icon d={icon} />
          </span>
        ) : (
          <Icon d={icon} />
        )}
        <div>{summary}</div>
      </div>
      {onExpand && (
        <button className="map-all" type="button" onClick={onExpand}>
          <Icon d="M3 9V3h6 M15 21h6v-6 M3 3l7 7 M21 21-7-7" />
          {expandLabel}
        </button>
      )}
      <div className="zoom">
        <button aria-label="Приблизить" type="button" onClick={() => map.current?.zoomIn()}>
          +
        </button>
        <button aria-label="Отдалить" type="button" onClick={() => map.current?.zoomOut()}>
          −
        </button>
      </div>
      <button
        aria-label="Показать весь маршрут"
        className="map-center"
        type="button"
        onClick={() => {
          map.current?.fit();
          onCenter && onCenter();
        }}
      >
        <Icon d={D.locate} />
      </button>
    </div>
  );
}
